import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  TRANSITION_DURATION,
  TYPE_BANNER_BANNER_LARGE,
} from "../PlaylistConstants";
import ScreenCard from "../../../../../app/src/Components/common/ScreenCard/ScreenCard";
import {
  evaluateItemClass,
  LIMIT_ITEMS,
} from "./utils";
import {
  actionTypeContainer,
  generateSlug,
  getContentCodeByLanguage,
  renderImageUrl,
} from "../../../../../app/src/Utils/utils";
import { URL_SCREEN } from "../../../../../app/src/Components/Routes/Location";

const ListScreenGridComponent = ({
  key,
  className,
  style,
  title,
  hasMoreContents,
  id,
  typeBanner,
  playlist,
  playSpinner,
  trigger,
  titleColor,
  turnOnLoading,
  contentId = null,
}) => {
  const [overOnCard, setOverOnCard] = useState(false);
  const { t } = useTranslation();

  const minimumItems =
    +playlist?.length < LIMIT_ITEMS ? " BlockGrid" : " ";

  return (
    <div className="MyCustomWidgetContainer custom-grid-widget" key={key}>
    <div className="PlaylistContainer GridContainer GroupWidget">
      <div className={"Playlist " + className} style={style}>
        <div className="Titulo" style={{ display: "flex" }}>
          <p style={{ width: "auto", color: titleColor }}>{title}</p>
          {hasMoreContents && (
            <Link
              to={`${actionTypeContainer(trigger).ROUTE}/${generateSlug(
                title
              )}/${id}`}
              style={{ padding: "0px 0px 20px 0px", display: "flex", width: "120px" }}
              className="Titulo button-link-secondary"
            >
              <div className="ShowMoreText">{t("ficha.showmore")}</div>
              <FontAwesomeIcon
                icon={faChevronRight}
                style={{ margin: "4px 0 0 5px" }}
              />
            </Link>
          )}
        </div>
        {playlist?.length > 0 && (
          <div
            className={
              "grid-container PlaylistCollection " +
              typeBanner +
              " " +
              minimumItems
            }
          >
            {playlist?.map((w, i) => {
              return (
                <div
                  className={evaluateItemClass({
                    i,
                    overOnCard,
                    playlist,
                    itemClass: "PlaylistItemContainer",
                  })}
                  key={i}
                  onMouseEnter={() => setOverOnCard(i)}
                  onMouseLeave={() => setOverOnCard(false)}
                >
                  <ScreenCard
                    item={w}
                    trigger={trigger}
                    contentId={contentId}
                    turnOnLoading={turnOnLoading}
                    titleClassName="PlaylistItemTitleGrid"
                    imageAlt={w.title}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      {playSpinner && (
        <div className="SpinnerContainer">
          <Spinner animation="border" />
        </div>
      )}
     </div>
    </div>
  );
};

export default ListScreenGridComponent;
